export default __webpack_public_path__ + "i18n/translations/translation-da.a509b03f.json";